"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalDocumentType = void 0;
var LegalDocumentType;
(function (LegalDocumentType) {
    LegalDocumentType["UNKNOWN"] = "Unknown";
    LegalDocumentType["KSC_HOSTED_TERMS_OF_USE"] = "KscHostedTermsOfUse";
    LegalDocumentType["KSC_HOSTED_PRIVACY_POLICY"] = "KscHostedPrivacyPolicy";
    LegalDocumentType["KSC_HOSTED_DATA_PROCESSING_AGREEMENT"] = "KscHostedDataProcessingAgreement";
    LegalDocumentType["KSC_PACKAGES_EULA"] = "KscPackagesEula";
    LegalDocumentType["KSC_PACKAGES_AGREEMENT"] = "KscPackagesAgreement";
})(LegalDocumentType || (exports.LegalDocumentType = LegalDocumentType = {}));
